<template>
  <div>
    <div ref="productList"
         class="product-list">
      <div v-if="goodsLoading && !isMobile">
        <el-skeleton :loading="goodsLoading"
                     animated>
          <template slot="template">
            <div style="display: flex;">
              <div style="margin-right: 20px;padding: 15px;"
                   v-for="(item, index) in 4"
                   :key="index">
                <el-skeleton-item variant="image"
                                  style="width: 250px; height: 250px;" />
                <div style="padding-top: 10px;">
                  <el-skeleton-item variant="h3"
                                    style="width: 50%;" />
                  <div class="product-price">
                    <el-skeleton-item variant="text"
                                      style="margin-right: 16px;" />
                    <el-skeleton-item variant="text"
                                      style="width: 30%;" />
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-skeleton>
      </div>
      <div class="product-item"
           v-for="(product, index) in products"
           :key="index"
           v-else>
        <div class="product-image"
             :style="{ height: productItemWidth + 'px !important' }">
          <img :src="product.goodsImage">
          <div v-if="product.tag"
               class="thumb__tag">
            <div class="tag-marquee">
              <p class="tag-marquee__track">
                <span class="tag-txt">
                  {{ product.tag }}
                </span>
                <span class="tag-txt tag-txt--dup"
                      aria-hidden="true">
                  {{ product.tag }}
                </span>
              </p>
            </div>
          </div>
        </div>
        <div style="padding: 10px;">
          <div class="product-name"
               :title="product.goodsName">
            {{ product.goodsName }}
          </div>
          <div style="display: flex;align-items: center;justify-content: space-between;">
            <div class="product-price">
              {{ currencySymbol }}{{ product.price.toFixed(2) }}
            </div>
            <div class="buy-now">
              <el-button type="primary"
                         class="buy-now-btn"
                         round
                         @click="handleBuyNow(product)"
                         size="small">
                {{ $t('buyNow') }}
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="nodata"
         v-if="products.length == 0 && !goodsLoading"
         style="margin-top: 100px;">
      <img src="/icon/nodata.png">
      <span>{{ $t('noData') }}</span>
    </div>

    <div class="loading-layout">
      <!-- 手机端初始加载状态 -->
      <div v-if="(goodsLoading && isMobile)"
           class="loading-more"
           style="margin-top: 50px; text-align: center;">
        <i class="el-icon-loading"></i>
        <span>{{ $t('dataLoading') }}</span>
      </div>
      <!-- 加载更多状态 -->
      <div v-if="loadingMore"
           class="loading-more"
           style="margin: 30px 0; text-align: center;">
        <i class="el-icon-loading"></i>
        <span>{{ $t('dataLoading') }}</span>
      </div>

      <!-- 已加载全部数据 -->
      <div v-if="!hasMore && products.length > 0"
           class="load-all"
           style="margin: 30px 0; text-align: center; color: #999;">
        {{ $t('loadingFinish') }}
      </div>
    </div>
  </div>
</template>

<script>
import storage from "@/utils/storage.js"
import productApi from '@/api/product'
export default {
  name: 'ProductList',
  props: {
    //商品关键词
    searchKeyword: {
      type: String,
      default: null
    },
    //排序方式
    sortBy: {
      type: String,
      default: ''
    },
    //一级分类 ID
    parentCateIds: {
      type: String,
      default: ''
    },
    //二级分类 ID
    cateIds: {
      type: String,
      default: ''
    },
    //商品品质
    tags: {
      type: String,
      default: ''
    },
    // 品牌批量
    brands: {
      type: String,
      default: ''
    },
    //商品分类（兼容旧版）
    categoryName: {
      type: String,
      default: null
    },
    //品牌名称
    brandName: {
      type: String,
      default: null
    },
    //达人 id
    expertId: {
      type: Number,
      default: null
    },
    //币种符号
    currencySymbol: {
      type: String,
      default: '￥'
    },
    //币种编号
    currencyId: {
      type: Number,
      default: 1
    },
    templateType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      productItemWidth: 0,
      goodsLoading: true, //是否显示骨架
      isMobile: window.innerWidth < 768,
      products: [],
      params: {
        pageNum: 1,
        pageSize: 20,
        orderByColumn: 'a.sort_order',
        isAsc: 'ascending'
      },
      loadingMore: false, // 加载更多的状态
      hasMore: true, // 是否还有更多数据
      isMounted: false,
    }
  },
  mounted() {
    // 组件挂载后添加滚动事件监听器
    this.isMounted = true
    window.addEventListener('scroll', this.handleScroll)
    // 组件销毁时移除滚动事件监听器
    this.$once('hook:destroyed', () => {
      window.removeEventListener('scroll', this.handleScroll)
    })
  },
  methods: {
    init() {
      this.products = []
      this.goodsLoading = true
      this.params.pageNum = 1
      this.hasMore = true
      window.scrollTo({
        top: this.scrollTop,
        behavior: 'smooth'
      })
      this.getGoodsList()
    },
    async getGoodsList() {
      try {
        var params = {
          ...this.params,
          expertId: this.expertId,
          currencyId: this.currencyId
        }

        // 新版分类 ID 参数：parentCateIds（一级）和 cateIds（二级）
        // 传了一级分类 ID 可以不用传二级，传了二级也要传一级
        if (this.parentCateIds) {
          params.parentCateIds = this.parentCateIds
          if (this.cateIds) {
            params.cateIds = this.cateIds
          }
        } else if (this.categoryName && this.categoryName != 'All') {
          // 兼容旧版 categoryName 参数
          if (this.categoryName == 'Best Sellers') {//商品分类
            if (this.templateType == 1) {
              params.orderByColumn = 'a.sort_order'
              params.isAsc = 'ascending'
            }
          } else if (this.categoryName == 'New Arrivals') {
            if (this.templateType == 1) {
              params.orderByColumn = 'a.upper_time'
              params.isAsc = 'descending'
            }
          } else {
            params.categoryName = this.categoryName
          }
        }

        //排序方式
        if (this.sortBy) {
          params.sortBy = this.sortBy
          delete params.orderByColumn
          delete params.isAsc
        }
        //商品品质
        if (this.tags) {
          params.tags = this.tags
        }
        //品牌批量
        if (this.brands) {
          params.brands = this.brands
        }
        //关键词
        if (this.searchKeyword) {
          params.goodsName = this.searchKeyword
        }
        //品牌
        if (this.brandName && this.brandName != 'All') {
          params.brandName = this.brandName
        }
        const res = await productApi.getGoodsList(params)
        const products = res.rows

        // 检查是否是第一页加载
        if (this.params.pageNum === 1) {
          // 第一页直接替换数据
          this.products = products
        } else {
          // 后续页追加数据
          this.products = [...this.products, ...products]
        }

        // 检查是否还有更多数据
        const total = res.total
        if (this.products.length >= total) {
          this.hasMore = false
        }

        // 重置加载状态
        this.goodsLoading = false
        this.loadingMore = false

        // 获取product-item的宽度
        this.$nextTick(() => {
          this.getProductItemWidth()
        })
      } catch (error) {
        console.error('获取商品列表失败:', error)
        if (this.params.pageNum === 1) {
          this.products = []
        }
        // 重置加载状态
        this.goodsLoading = false
        this.loadingMore = false
      }
    },

    // 加载更多数据
    loadMore() {
      if (this.loadingMore || !this.hasMore || this.goodsLoading) {
        return
      }

      this.loadingMore = true
      this.params.pageNum++
      this.getGoodsList()
    },

    // 处理滚动事件
    handleScroll() {
      if (!this.isMounted || this.loadingMore || !this.hasMore) {
        return
      }
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      const clientHeight = document.documentElement.clientHeight || window.innerHeight

      // 当距离底部小于230px时，加载更多数据
      if (scrollHeight - scrollTop - clientHeight < 230) {
        this.loadMore()
      }
    },
    // 获取product-item的宽度
    getProductItemWidth() {
      // querySelector只会返回匹配的第一个元素，符合需求
      const productItem = document.querySelector('.product-item')
      if (productItem) {
        // 获取元素的宽度
        this.productItemWidth = productItem.offsetWidth
      }
      this.$nextTick(() => {
        this.initTagMarquees()
      })
    },
    /** 标签文案超出容器宽度时启用横向循环滚动 */
    initTagMarquees() {
      const root = this.$refs.productList
      if (!root) return
      const tags = root.querySelectorAll('.thumb__tag')
      tags.forEach((tag) => {
        tag.classList.remove('is-scroll')
        const box = tag.querySelector('.tag-marquee')
        const track = tag.querySelector('.tag-marquee__track')
        const single = tag.querySelector('.tag-txt:not(.tag-txt--dup)')
        if (!box || !track || !single) return
        if (single.scrollWidth > box.clientWidth) {
          tag.classList.add('is-scroll')
          const duration = Math.max(4, track.scrollWidth / 40)
          track.style.setProperty('--tag-dur', `${duration}s`)
        } else {
          track.style.removeProperty('--tag-dur')
        }
      })
    },
    //跳转三方代购平台地址
    handleBuyNow(gooods) {
      this.$emit('goods-selected', gooods)
    },
  }
}
</script>

<style scoped>
.product-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 10px;
  max-width: 1200px;
  margin: 20px auto;
}

.product-item {
  /* box-shadow: 1px 1px 10px #ccc; */
  border-radius: 8px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  cursor: pointer;
  background: var(--pupop-bg-color);
}

.product-item:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

/* 确保按钮在图片上方显示 */
.product-image {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.product-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  border-radius: 8px;
}

/* 角标：与首页商品墙一致，最大 60% 宽，超出循环滚动 */
.product-image .thumb__tag {
  position: absolute;
  top: 6px;
  right: 6px;
  max-width: 50%;
  color: var(--primary-color);
  background:
    linear-gradient(hsl(from var(--primary-color) h s l / 0.4), hsl(from var(--primary-color) h s l / 0.4)),
    hsl(from var(--background-color) h s l / 0.5);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  overflow: hidden;
}

.product-image .tag-marquee {
  overflow: hidden;
  width: 100%;
}

.product-image .tag-marquee__track {
  display: inline-flex;
  align-items: center;
  width: max-content;
  max-width: none;
  margin: 0;
  padding: 0 8px;
  white-space: nowrap;
  animation: none;
}

.product-image .thumb__tag .tag-txt {
  flex: 0 0 auto;
  background: linear-gradient(90deg,
      var(--primary-color) 0%,
      var(--primary-color) 40%,
      #fff 50%,
      var(--primary-color) 60%,
      var(--primary-color) 100%);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: tagTextBg 4s ease infinite;
}

.product-image .thumb__tag:not(.is-scroll) .tag-txt--dup {
  display: none;
}

.product-image .thumb__tag.is-scroll .tag-txt--dup {
  padding-left: 1.25em;
}

.product-image .thumb__tag.is-scroll .tag-marquee__track {
  -webkit-animation: tagMarquee var(--tag-dur, 6s) linear infinite;
  animation: tagMarquee var(--tag-dur, 6s) linear infinite;
}

@keyframes tagTextBg {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

@-webkit-keyframes tagMarquee {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  100% {
    -webkit-transform: translate3d(-50%, 0, 0);
    transform: translate3d(-50%, 0, 0);
  }
}

@keyframes tagMarquee {
  0% {
    transform: translate3d(0, 0, 0);
  }

  100% {
    transform: translate3d(-50%, 0, 0);
  }
}

.product-item:hover .product-image img {
  transform: scale(1.05);
}

.product-name {
  font-size: 15px;
  color: var(--link-color);
  margin-bottom: 10px;
  font-weight: 600;
  height: 40px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.product-price {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

.buy-now {
  font-size: 14px;
  color: #999;
}

/* 加载中动画效果 */
.loading-more {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 10px;
}

.loading-more .el-icon-loading {
  font-size: 24px;
  color: #666;
  animation: rotating 2s linear infinite;
}

.loading-more span {
  margin-left: 10px;
  color: #999;
  font-size: 16px;
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* 已全部加载样式 */
.load-all {
  font-size: 16px;
  padding: 10px 0;
}

.buy-now-btn {
  font-weight: bold;
  font-size: 15px;
}

.loading-layout {
  display: flex;
  max-width: 1200px;
  width: 100%;
  justify-content: center;
  margin: 0 auto;
}

/* 响应式调整 */
@media (max-width: 1200px) {
  .product-list {
    padding: 0;
  }
}

@media (max-width: 992px) {
  .product-list {
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 10px;
  }

  .product-name {
    font-size: 15px;
    height: 38px;
    line-height: 20px;
  }

  .product-price {
    font-size: 18px;
  }

  .buy-now-btn {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .product-list {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 10px;
    margin: 15px auto;
  }

  .product-name {
    font-size: 15px;
    height: 38px;
    line-height: 20px;
  }

  .product-price {
    font-size: 17px;
  }

  .buy-now-btn {
    font-size: 14px;
  }

  .loading-layout {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .product-list {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 8px;
    margin: 10px auto;
  }

  .product-name {
    font-size: 15px;
    height: 38px;
    line-height: 20px;
  }

  .loading-layout {
    width: 100%;
  }

  .product-price {
    font-size: 16px;
  }

  .buy-now-btn {
    font-size: 13px;
  }
}
</style>